module.exports = __webpack_public_path__ + "img/business.1912c269.svg";